'use strict';

let base = require('../product/base');
const { alertMessage } = require('../common/common');
const { SELECTORS, EVENTS } = require('../cart/variables');

/**
 * Generates the modal window on the first call.
 *
 */
const getModalHtmlElement = () => {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    let htmlString =
        '<div class="modal cc-modal js-wishlist-edit cc-modal--edit cc-fade" id="editWishlistProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog cc-modal__dialog quick-view-dialog">' +
        '<div class="modal-content cc-modal__content">' +
        '<div class="cc-modal__header js-wishlist-modal-header">' +
        '<span class="cc-modal__title js-modal-title" role="heading" aria-level="2"></span>' +
        '</div>' +
        '<div class="cc-modal__inner">' +
        '<div class="modal-body"></div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('.page').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
const parseHtml = (html) => {
    let $html = $('<div>').append($.parseHTML(html));

    let body = $html.find('.product-quickview');
    let footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
const fillModalElement = (editProductUrl,origin) => {
    $('#editWishlistProductModal').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: (data) => {
            let parsedHtml = parseHtml(data.renderedTemplate);
            let parsedHtmlAddToCartButton =  data.renderedTemplateAddToCartButton;

            $('#editWishlistProductModal .modal-body').empty();
            $('#editWishlistProductModal .modal-body').html(parsedHtml.body);
            $('#editWishlistProductModal .modal-footer').html(
                parsedHtml.footer
            );
            $('#editWishlistProductModal .modal-header .close .sr-only').text(
                data.closeButtonText
            );
            $('#editWishlistProductModal .enter-message').text(
                data.enterDialogMessage
            );

            $('#editWishlistProductModal').modal('show');
            $('body').trigger('editwishlistproduct:ready');

            if (origin !== '') {
                $('#editWishlistProductModal .js-quickviewAction-wrap').empty();
                $('#editWishlistProductModal .js-quickviewAction-wrap').html(parsedHtmlAddToCartButton);
            }

            $.spinner().stop();
        },
        error: () => {
            $('#editWishlistProductModal').spinner().stop();
        }
    });
}

/**
 * toggles the public / private status of the item or wishlist item
 * @param {string} listID - the order model
 * @param {string} itemID - the customer model
 * @param {Object} callback - function to run if the ajax call returns with an
 *                        error so that the checkbox can be reset to it's original state
 */
const updatePublicStatus = (listID, itemID, callback) => {
    let url = $('#isPublicList').data('url');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            listID: listID,
            itemID: itemID
        },
        success: function (data) {
            if (callback && !data.success) {
                callback();
            }
            alertMessage(data.msg, 'cc-alert--success');
        },
        error: function (err) {
            if (callback) {
                callback();
            }
            alertMessage(err.msg, 'cc-alert--danger');
        }
    });
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
const renderNewPageOfItems = (pageNumber, spinner, focusElementSelector) => {
    let publicView = $('.wishlistItemCardsData').data('public-view');
    let listUUID = $('.wishlistItemCardsData').data('uuid');
    let url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    let scrollPosition = document.documentElement.scrollTop;
    let newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    })
        .done(function (data) {
            $('.wishlistItemCards').empty();
            $('body .wishlistItemCards').append(data);

            if (focusElementSelector) {
                $(focusElementSelector).focus();
            } else {
                document.documentElement.scrollTop = scrollPosition;
            }
        })
        .fail(function () {
            $('.more-wl-items').remove();
        });
    $.spinner().stop();
}

module.exports = {
    removeFromWishlist: () => {
        $('body').on('click', '.remove-from-wishlist', function (e) {
            e.preventDefault();
            let url = $(this).data('url');
            let elMyAccount = $('.account-wishlist-item').length;
            let countWrap = $('.js-wishlist');
            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $('.wishlist-account-card').spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();

                    },
                    error: function () {
                        let $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        let msg = $elToAppend.data('error-msg');
                        alertMessage(msg, 'cc-alert--danger');
                    }
                });
                // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function (data) {

                        let pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;

                        if (typeof data.wishlistLength !== "undefined") {
                            $(countWrap).text(data.wishlistLength);
                            if (data.wishlistLength === 0) {
                                location.reload();
                                return;
                            } else {
                                $(countWrap).addClass('d-inline-flex');
                                $(countWrap).removeClass('d-none');
                            }
                            $('.js-wishlist-qty').text(data.wishlistLength);
                        }

                        renderNewPageOfItems(pageNumber, false);
                        alertMessage(data.msg, 'cc-alert--success');
                    },
                    error: function () {
                        $.spinner().stop();
                        let $elToAppendWL = $('.wishlistItemCards');
                        let msg = $elToAppendWL.data('error-msg');
                        alertMessage(msg, 'cc-alert--danger');
                    }
                });
            }
        });
    },

    viewProductViaEdit: () => {
        $('body').on('click', '.edit-add-to-wishlist .edit', function (e) {
            e.preventDefault();
            let origin = '';
            if ($(this).data('path')) {
                origin = $(this).data('path');
            }
            let editProductUrl = $(this).attr('href');
            $(e.target).trigger('editwishlistproduct:show');
            getModalHtmlElement();
            fillModalElement(editProductUrl,origin);
          
        });
    },

    viewProductViaSelectAttribute: () => {
        $('body').on('click', '.select-attributes-btn', function (e) {
            e.preventDefault();

            let editProductUrl = $(this).data('get-product-url');
            getModalHtmlElement();
            fillModalElement(editProductUrl);
        });
    },

    focusEditWishlistProductModal: () => {
        $('body').on(
            'shown.bs.modal',
            '#editWishlistProductModal',
            function () {
                $('#editWishlistProductModal')
                    .siblings()
                    .attr('aria-hidden', 'true');
                $('#editWishlistProductModal .close').focus();
                $('.js-wishlist-edit .js-slider').slick();
                const title = $('.js-edit-product-modal').data('text');
                const $closeIcon = $('.js-close-wishlist-modal');
                const $modalHeader = $(".js-wishlist-modal-header");
                const $closeButton = $('.js-close-wishlist-button');
                
                const pidModal = $('.js-wishlist-edit').find('.product-quickview').data('pid');
                let valueId = '';
                $('.js-product-card-wishlist').each((el,elem) => {
                    if ($(elem).hasClass('pid-' + pidModal)) {
                        valueId = $(elem).find('.options-select').data('value-id');
                    }
                });
                $('.js-wishlist-edit').find('.product-option input').each((el,elem) => {
                    $(elem).removeClass('selected');
                    if ($(elem).data('value-id') == valueId) {
                        $(elem).addClass('selected');
                    }
                });
                $(this).find('.cart-and-ipay .update-cart-url').attr('data-selected-quantity', 1);
                $('.js-modal-title').text(title);
                if ($modalHeader.length && $closeButton.length) {
                    const $clonedButton = $closeButton.clone();
                    $modalHeader.append($clonedButton);
                    $clonedButton.removeClass('d-none');
                }
            }
        );
    },

    onClosingEditWishlistProductModal: () => {
        $('body').on(
            'hidden.bs.modal',
            '#editWishlistProductModal',
            function () {
                $('#editWishlistProductModal').remove();
                $('.modal-backdrop').remove();
                $('body').removeClass('modal-open');

                $('#editWishlistProductModal')
                    .siblings()
                    .attr('aria-hidden', 'false');
            }
        );
    },

    updateWishlistUpdateButton: () => {
        $('body').on('product:updateAddToCart', function (e, response) {
            response.$productContainer
                .find('.btn-update-wishlist-product')
                .attr(
                    'disabled',
                    !response.product.readyToOrder ||
                        !response.product.available
                );
        });
    },

    updateWishListItem: () => {
        $('body').on('click', '.btn-update-wishlist-product', function (e) {
            e.preventDefault();

            let updateButtonBlock = $(this)
                .closest('.wishlist-item-update-button-block')
                .find('.update-wishlist-url');
            let updateProductUrl = updateButtonBlock.val();
            let uuid = updateButtonBlock.data('uuid');

            let form = {
                uuid: uuid,
                pid: $(this).data('pid')
            };

            $('#editWishlistProductModal').spinner().start();

            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function () {
                    $.spinner().start();
                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');
                    let pageNumber =
                        $('.wishlistItemCardsData').data('page-number') - 1;
                    renderNewPageOfItems(
                        pageNumber,
                        false,
                        '.product-info .edit-add-to-wishlist .edit:first'
                    );
                },
                error: function () {
                    let msg = $('.btn-update-wishlist-product').data(
                        'error-msg'
                    );

                    $('#editWishlistProductModal').spinner().stop();
                    $('#editWishlistProductModal').remove();
                    $('.modal-backdrop').remove();
                    $('body').removeClass('modal-open');

                    if ($('.update-wishlist-messages').length === 0) {
                        $('body').append(
                            '<div class="update-wishlist-messages "></div>'
                        );
                    }

                    $('.update-wishlist-messages').append(
                        '<div class="update-wishlist-alert text-center alert-danger">' +
                            msg +
                            '</div>'
                    );

                    setTimeout(function () {
                        $('.update-wishlist-messages').remove();
                    }, 5000);
                }
            });
        });
    },

    toggleWishlistStatus: () => {
        $('#isPublicList').on('click', function () {
            let listID = $('#isPublicList').data('id');
            updatePublicStatus(listID, null, null);
        });
    },

    toggleWishlistItemStatus: () => {
        $('body').on('click', '.wishlist-item-checkbox', function () {
            let itemID = $(this)
                .closest('.wishlist-hide')
                .find('.custom-control-input')
                .data('id');
            let el = $(this).siblings('input');
            let resetCheckBox = function () {
                return el.prop('checked')
                    ? el.prop('checked', false)
                    : el.prop('checked', true);
            };

            updatePublicStatus(null, itemID, resetCheckBox);
        });
    },

    addToCartFromWishlist: () => {
        $('body').on('click', '.add-to-cart, .add-to-cart-global ', function () {
            let pid;
            let addToCartUrl;
            let pidsQty;

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).data('pid');
            addToCartUrl = $(this).data('url');
            pidsQty = parseInt(
                $(this).closest('.product-info').find('.quantity').val(),
                10
            );

            let form = {
                pid: pid,
                quantity: pidsQty
            };

            if ($(this).data('option')) {
                form.options = JSON.stringify($(this).data('option'));
            }            
        });
    },
    moreWLItems: () => {
        $('body').on('click', '.more-wl-items', function () {
            let pageNumber = $('.wishlistItemCardsData').data('page-number');
            renderNewPageOfItems(pageNumber, true);
        });
    },
    copyWishlistLink: () => {
        $('body').on('click', '#copyShareUrlBtn', function () {
            let $btn = $('#copyShareUrlBtn');
            let shareUrl = $btn.data('url');
            let msg = $('.js-copy-link').text();
            navigator.clipboard.writeText(shareUrl);
            alertMessage(msg, 'cc-alert--success');
        });
    },
    submitWishlistSearch: () => {
        $('body').on('click', '#wishlist-search button', function (e) {
            let firstName = $('#wishlist-search-first-name').val();
            let lastName = $('#wishlist-search-last-name').val();
            let email = $('#wishlist-search-email').val();

            if (
                (!firstName && !lastName && !email) ||
                (firstName && !lastName && !email) ||
                (!firstName && lastName && !email)
            ) {
                e.preventDefault();
                $('.wishlist-error-search div').addClass('alert alert-danger');
                let errorText = $('.wishlist-error-search').data('error-msg');
                $('.wishlist-error-search div').html(errorText);
            }
        });
    },
    moreWLSearchResults: () => {
        $('body').on('click', '.more-wl-results', function () {
            let firstName = $(this).data('search-fname');
            let lastName = $(this).data('search-lname');
            let pageNumber = $(this).data('page-number');
            let uuids = [];
            $('.wl-hit').each(function () {
                uuids.push($(this).find('a').data('id'));
            });
            let url = $(this).data('url');
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'POST',
                data: {
                    firstName: firstName,
                    lastName: lastName,
                    uuids: JSON.stringify(uuids),
                    pageNumber: ++pageNumber
                },
                success: function (data) {
                    if (data.results.changedList) {
                        $('.wl-hits .wl-hit').remove();
                    }
                    $('#result-count').html(data.results.totalString);
                    data.results.hits.forEach(function (hit) {
                        let divString =
                            '<div class="row wl-hit">' +
                            '<div class="text-left col-6">' +
                            hit.firstName +
                            ' ' +
                            hit.lastName +
                            '</div>' +
                            '<div class="text-right col-6">' +
                            '<a href="' +
                            hit.url +
                            '" title="' +
                            hit.urlTitle +
                            '" data-id="' +
                            hit.id +
                            '">' +
                            hit.urlText +
                            '</a>' +
                            '</div>' +
                            '</div>';
                        $('.wl-hits').append(divString);
                    });
                    if (data.results.showMore) {
                        $('.find-another-wl .more-wl-results').data(
                            'page-number',
                            data.results.pageNumber
                        );
                    } else {
                        $('.find-another-wl .more-wl-results').remove();
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    }
};

$('body').on('product:afterAddToCart', function () {
    $('#editWishlistProductModal').modal('hide');
});

$('body').on('click', SELECTORS.updateCartProductGlobal, (e) => {
    e.preventDefault();
    const $this = $(e.currentTarget);
    const updateProductUrl = $this.closest('.cart-and-ipay').find('.update-cart-url').val();
    const selectedQuantity = $this.closest('.cart-and-ipay').find('.update-cart-url').attr('data-selected-quantity');
    const selectedOptionValueId = $this.closest('.detail-panel').find('.options-select.selected').data('value-id');
    const optionId = $this.closest('.detail-panel').find('.product-option').data('option-id');
    const uuid = $this.closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

    let form = {
        uuid: uuid,
        pid: base.getPidValue($this),
        quantity: selectedQuantity,
        optionId: optionId,
        selectedOptionValueId: selectedOptionValueId
    };

    $('body').trigger(EVENTS.cartBeforeUpdate);

    if (updateProductUrl) {
        $.ajax({
            url: updateProductUrl,
            type: 'post',
            context: this,
            data: form,
            dataType: 'json',
            success: (data) => {
                $('#editWishlistProductModal').modal('hide');
                updateProductDetails(data, uuid);

                if (data.uuidToBeDeleted) {
                    $('.uuid-' + data.uuidToBeDeleted).remove();
                }

            },
            error: (err) => {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
                }
            }
        });
    }
});

const updateProductDetails = (data, uuid) => {
    $('.product-info.uuid-' + uuid).replaceWith(data.wishlistProductCardRenderedTemplate);
}